import React, { Component } from 'react';
import classNames from 'classnames';
import Style from './index.less';
import { IRightSideBarProps, IRightSideBarService, IRightSideBarState } from '../interface';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import ReactView from '@src/slide/infrastructure/module/independent/view-service-define/react/react-view';
import RightSideBarModel from '../model';
import { RightSideBarWrapper } from './wrapper';


export default class RightSideBar extends Component<IRightSideBarProps, IRightSideBarState> {
    private service: IRightSideBarService;

    public constructor(props) {
        super(props);
        this.service = props.getRightSideBarService();
        this.service.setViewDelegate(new ReactView(this));
    }

    public render() {
        const {
            zIndex = 1,
            top = 8,
            // 与底边状态栏间距为40px
            bottom = 40,
        } = this.props;
        const state = this.getState();
        const rsBarStyle = { width: state.width, left: 'calc(100vw - 288px)' };
        return (
            <div
                className={classNames(
                    Style['rs-bar-container'],
                    { 'rs-bar-container-pad': browser.isPad },
                )}
                id={'rs-bar-container'}
                data-display={state.visible}
                style={{
                    display: state.visible ? 'block' : 'none',
                    zIndex,
                    top: `${top}px`,
                    height: `calc(100% - ${top}px - ${bottom}px)`,
                    ...rsBarStyle,
                }}> {
                    this.service.getModules().map(m => <RightSideBarWrapper
                        id={m.name}
                        key={m.name}
                        ref={
                            e => m.wrapper = e
                        }
                        willShow={() => this.service.onModuleWillShow(m)}
                        didHide={() => this.service.onModuleDidHide(m)} />)
                }
            </div>
        );
    }

    private getState() {
        const state = this.service.getModel();
        return state as RightSideBarModel;
    }
}


